<template>
  <page-content>
    <edit-field-header
      :title="title"
      @routerBack="$router.back()"
    />

    <edit-field
      ref="edit_field"
      :is-edit="true"
      :fields="fields"
      :row-data="row_data"
      post-api="/memberqrcode/UpdateMemberQrCode"
      finish-router="kioskMemberQr"
      permission="Kiosk_QrCode_Edit"
    >
      <template #facility="scope">
        <SlotFacility
          :row-data="scope.rowData" :company-id="scope.rowData.companyID"
          :facility-id="scope.rowData.facilityID" :is-edit="scope.isEdit" :disabled="scope.rootItem.edit_disable"
        />
      </template>

      <template #floor="scope">
        <SlotFloor :row-data="scope.rowData" :facility-id="scope.rowData.facilityID"
                   :disabled="scope.rootItem.edit_disable"
        />
      </template>

      <template #room="scope">
        <SlotRoom :row-data="scope.rowData" :floor-id="scope.rowData.floorID" :disabled="scope.rootItem.edit_disable"/>
      </template>

      <template #bed="scope">
        <SlotBed :row-data="scope.rowData" :room-id="scope.rowData.roomID" :disabled="scope.rootItem.edit_disable"/>
      </template>

      <template v-slot:qrCodes="scope">
        <slot-qr-codes
          ref="slot_qr_codes"
          :root-item="scope.rootItem"
          :items="row_data['externalQrCodes']"
          @updateValues="(value) => row_data['externalQrCodes'] = value"
        />
      </template>
    </edit-field>
  </page-content>
</template>

<script>
import fields from './fields'
import EditField from '@/components/EditField2'
import EditFieldHeader from '@/components/EditFieldHeader'
import common from '@/common'
import PageContent from '@/components/PageContent'
import SlotFacility from '@/views/member/SlotFacility'
import SlotFloor from '@/views/member/SlotFloor'
import SlotRoom from '@/views/member/SlotRoom'
import SlotBed from '@/views/member/SlotBed'
import SlotQrCodes from '@/views/kiosk/kskMemberQr/FieldModalQrCodes.vue'
import _ from 'lodash'

export default {
  name: 'Edit',
  components: {
    SlotQrCodes,
    SlotBed,
    SlotRoom,
    SlotFloor,
    SlotFacility,
    PageContent,
    EditFieldHeader,
    EditField,
    fields,
  },
  data() {
    return {
      title: common.getMenuName('kioskMemberQr') + ' - ' + common.getI18n('common.edit'),
      id: this.$router.currentRoute.params.id,
      fields,
      row_data: {
        externalQrCodes: []
      }
    }
  },
  mounted() {
    this.id = common.decrypt(this.id)
    if (this.id === undefined) {
      this.$router.replace({ path: '/' + this.$route.path.split('/')[1] })
      return false
    }
    common.apiGetData('/memberqrcode/GetMemberQrCodeInfo?memberID=' + this.id)
      .then(res => {
        this.row_data = _.cloneDeep(res.data.member)
      })
  },
  methods: {
    // beforeSubmit(callback) {
    //   const rowData = _.clone(this.row_data)
    //   if(this.row_data?.qrCodes && this.row_data.qrCodes[0]) {
    //     rowData.qrCode = this.row_data.qrCodes[0] ?? null
    //     delete rowData.qrCodes
    //   }
    //   callback(true, rowData)
    // },
    // submitAction(rowData, api, finishRouter) {
    //   this.$requestWehealth({
    //     method: 'post',
    //     url: api,
    //     data: rowData
    //   })
    //     .then(res => {
    //       this.$router.push({ name: finishRouter })
    //     })
    // }
  }
}
</script>

<style scoped>

</style>
